<template>
  <div>
    <label for="cep" class="required">CEP:</label>
    <input v-model="enderecoEditado.cep" type="text" id="cep" placeholder="" @keyup="emitEndereco" @keypress="isNumber"
      @focusout="searchCep()" maxlength="8" :readonly="apenasLeitura" />

    <br />
    <label for="endereco" class="required">Endereço:</label>
    <input v-model="enderecoEditado.endereco" type="text" id="endereco" placeholder="" @keyup="emitEndereco"
      class="estilo60" :readonly="apenasLeitura" />

    <br />
    <label for="numero" class="required">Num.:</label>
    <input v-model="enderecoEditado.numero" type="text" id="numero" placeholder="" @keyup="emitEndereco" class="estilo20"
      :readonly="apenasLeitura" />

    <br />
    <label for="complemento">Complemento:</label>
    <input v-model="enderecoEditado.complemento" type="text" id="complemento" placeholder="" @keyup="emitEndereco"
      class="estilo60" />

    <br />
    <label for="bairro" class="required">Bairro:</label>
    <input v-model="enderecoEditado.bairro" type="text" id="bairro" placeholder="" @keyup="emitEndereco" class="estilo60"
      :readonly="apenasLeitura" />

    <br />
    <label for="cidade" class="required">Cidade:</label>
    <input v-model="enderecoEditado.cidade" type="text" id="cidade" placeholder="" @keyup="emitEndereco" class="estilo60"
      :readonly="apenasLeitura" />

    <br />
    <label for="estado" class="required">Estado:</label>
    <input v-model="enderecoEditado.estado" type="text" id="estado" placeholder="" @keyup="emitEndereco" class="estilo10"
      :readonly="apenasLeitura" />

    <br />
    <label for="pontoReferencia">Ponto de Referência:</label>
    <input v-model="enderecoEditado.pontoReferencia" type="text" id="pontoReferencia" placeholder="" @keyup="emitEndereco"
      class="estilo60" />
  </div>
</template>
  
<script>
//axios para consulta de cep, nao usa token
import axiosCep from 'axios'

export default {
  name: 'Endereco',
  emits: ['endereco-informado'],
  props: {
    endereco: Object,
    apenasLeitura: Boolean
  },

  data() {
    return {
      enderecoEditado: { ...this.endereco }
    };
  },

  methods: {

    emitEndereco() {
      this.$emit('endereco-informado', this.enderecoEditado);
    },

    isNumber(val) {
      if (isNaN(Number(val.key))) {
        return val.preventDefault();
      }
    },

    searchCep() {
      if (this.enderecoEditado.cep != null && this.enderecoEditado.cep.length == 8) {
        axiosCep.get(`https://viacep.com.br/ws/${this.enderecoEditado.cep}/json/`)
          .then((response) => {
            if (!response.data.erro) {
              this.enderecoEditado.endereco = response.data.logradouro
              this.enderecoEditado.bairro = response.data.bairro
              this.enderecoEditado.cidade = response.data.localidade
              this.enderecoEditado.estado = response.data.uf
            } else {
              this.$swal.fire({ title: 'CEP', html: 'CEP ' + this.enderecoEditado.cep + ' não encontrado!', focusConfirm: true })
            }
          })
          .catch((error) => {
            console.log(error);
            this.$swal.fire({ title: 'Erro ocorrido', html: "Ocorreu um erro durante a busca de CEP!", icon: 'error' });
          })
      }
    },

    resetForm() {
      this.enderecoEditado = {
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        pontoReferencia: '',
        estado: ''
      };
    }
  },

  mounted() {

    // Inicializa enderecoEditado com todas as chaves e valores null
    // Importante para forçar a existencia de todos os campos
    this.enderecoEditado = {
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        pontoReferencia: null,
        estado: null
    };

    // Atualiza enderecoEditado com os valores de this.endereco, se disponíveis
    if (this.endereco) {
      this.enderecoEditado = { ...this.endereco };
    }
  },

  watch: {
    endereco: {
      handler(newValue) {
        this.enderecoEditado = { ...newValue };
      },
      deep: true // IMPORTANTE: vê mudanças nas propriedades
    }
  }

};
</script>
  
<style src="../css/transporte.css"></style>